import React, {
  useState, 
  useEffect
} from 'react'
import { api } from 'data/api'
import { 
  useParams
} from 'react-router-dom'
import { 
  useUser
} from 'data/hooks'
import {
  Form,
  Upload,
  Image
} from 'antd'

const UploadField = props => { 

  const form = Form.useFormInstance()
  const [ formContext, setFormContext ] = useState()

  const gameId = useParams().gameId || playmotiv.game.gameId
  const { userId } = useUser()
  const { eventId } = useParams()
  const { value, onChange } = props
  const [ status, setStatus ] = useState('waiting')
  const [ fileList, setFileList ] = useState([])

  const beforeUpload = file => {
    
    setStatus('uploading')
    setFileList([])

    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'

    if (!isJpgOrPng) { setStatus('errornojpg') }

    const isLt2M = file.size / 1024 / 1024 < 2
    if (!isLt2M) { setStatus('errorbig') }

    return isJpgOrPng && isLt2M
  }

  const uploadFile = uploadData => {

    onChange() 
    setStatus('uploading')
    setFileList([])

    let data = new FormData();
    data.append('userid', userId);
    data.append('gameid', gameId);
    data.append('eventid', eventId || 'eventid');
    data.append('surveyid', props.parent.attribs['data-blockid'] );
    data.append('questionid', props.parent.parent.parent.attribs['data-blockid'] );
    data.append('image', uploadData.file)

    return window.fetch(
      `${api.core.url}/upload/survey`,
      {
        ...api.core.options,
        method: 'POST',
        body: data
      }
    )
    .then(response => {

      if (response.status != 200) { setStatus('errorserver') } 
      else {

        response.json()
        .then(result => {
          
          onChange(result.fileurl) 
          setStatus('done')
        })
      }  
    })
  }
  
  useEffect(() => {

    if(form) {
      
      setFormContext(form)
    }

  }, [form])

  return <Upload
    name={ props.parent.attribs['data-blockid'] }
    beforeUpload={ beforeUpload }
    customRequest={ uploadFile }
    showUploadList={ false }
    fileList={ fileList }
    disabled={ formContext?.eventData?.instance.closed }
  >
    <div className="Uploader">
      { 
        value &&
        <Image
          className="Image"
          preview={false}
          src={value}
        />
      }
      <div className="Message">
        { status == 'waiting' && 'Selecciona imagen' }      
        { status == 'uploading' && 'Guardando...' }       
        { status == 'done' && 'Cambia la imagen' }         
        { status == 'errorserver' && 'Ha habido un error en el servidor, vuelve a intentarlo' }     
        { status == 'errornojpg' && '¡Selecciona imágenes JPG o PNG!' }            
        { status == 'errorbig' && 'Selecciona una imagen menor de 2MB!' }         
      </div>
    </div>
  </Upload>
}

export const UploadMedia = props => {

  const required = props.parent.attribs['data-required'] == 'true'

  return <div className="wp-block-playmotivcloud-surveyanswer upload">
    <Form.Item
      name={ props.parent.attribs['data-blockid'] }
      rules={[{ required: required, message: "Este campo es obligatorio" }]}
    >
      <UploadField { ...props } />
    </Form.Item>
  </div>
}